import { useContext } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ThemeContext } from 'src/theme/ThemeProvider';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from '@mui/material';

function ThemeToggle() {
  const theme = useTheme();
  const setThemeName = useContext(ThemeContext);
  const isDark = theme.palette.mode === 'dark';

  const toggleTheme = () => {
    setThemeName(isDark ? 'PureLightTheme' : 'PureDarkTheme');
  };

  return (
    <Tooltip arrow title={isDark ? 'Light Mode' : 'Dark Mode'}>
      <IconButton color="primary" onClick={toggleTheme}>
        {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
}

export default ThemeToggle; 